import React from "react";

const SectionTitle = ({ title }) => {
  return <h2 className="mb-10 uppercase text-6xl text-gray-700">{title}</h2>;
};

export default SectionTitle;
